import {Component, OnInit} from '@angular/core';
import {TenantConfig} from '../model/tenant-config';
import {TenantConfigService} from '../service/tenant-config.service';

@Component({
    selector: 'app-landing',
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.css'],
    imports: [],
    standalone: true
})
export class LandingComponent implements OnInit {

    tenant!: TenantConfig;

    constructor(tenantConfigService: TenantConfigService) {
        this.tenant = tenantConfigService.current;
    }

    ngOnInit(): void {
    }

}
